import React from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { selectShipmentDetails } from 'apps/booking/utils/selectors/shipment'
import { trackingRequirementFullDescription } from 'apps/booking/utils/trackingRequirements'
import { InfoIcon } from 'transfix-icons'

export const TrackingRequirements = () => {
  const { shipperTrackingSegment } = useSelector(selectShipmentDetails)
  const { description, level, title } = shipperTrackingSegment || {}
  const levelDescription = level ? trackingRequirementFullDescription.get(level) : ''

  return (
    <>
      {level && (
        <div>
          <span className='b'>
            Level {level}: {description}
          </span>
          <Tooltip
            trigger={
              <span>
                <InfoIcon className='inline ml2' />
              </span>
            }>
            <div>
              <p className='b'>{title || ''}</p>
              <p>{levelDescription}</p>
            </div>
          </Tooltip>
        </div>
      )}
    </>
  )
}
